import {
	ACTION,
	ACTION_SUBJECT,
	ACTION_SUBJECT_ID,
	EVENT_TYPE,
} from '@atlaskit/editor-common/analytics';

import { type OpenReadingAidsPopupSource } from '../types';

const defineButtonClickedPayload = (readingAidsSessionId: string) =>
	({
		action: ACTION.CLICKED,
		actionSubject: ACTION_SUBJECT.BUTTON,
		actionSubjectId: ACTION_SUBJECT_ID.AI_DEFINITIONS_DEFINE_BUTTON,
		eventType: EVENT_TYPE.UI,
		attributes: {
			readingAidsSessionId,
		},
	}) as const;

const autoHighlightClickedPayload = (readingAidsSessionId: string) =>
	({
		action: ACTION.CLICKED,
		actionSubject: ACTION_SUBJECT.DECORATION,
		actionSubjectId: ACTION_SUBJECT_ID.AI_DEFINITIONS_AUTO_HIGHLIGHT,
		eventType: EVENT_TYPE.UI,
		attributes: {
			readingAidsSessionId,
		},
	}) as const;

export const getOpenReadingAidsPopupAnalyticsPayload = ({
	source,
	readingAidsSessionId,
}: {
	source: OpenReadingAidsPopupSource;
	readingAidsSessionId: string;
}) => {
	return source === 'define-button-click'
		? defineButtonClickedPayload(readingAidsSessionId)
		: autoHighlightClickedPayload(readingAidsSessionId);
};
